import config from 'helpers/configHelper';

export const BASE_URL = config.beUrl;
export const BASE_FE_URL = config.feUrl;
export const MAILJET_TOKEN = config.mailjetToken;
